<template>
    <div>
        <v-row class="mt-4">
            <v-col cols="6">
                <v-card class="mt-4">
                    <v-card-title class="subtitle-2 font-weight-bold">작성한 견적</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="estimatesHeaders" :items="estimates">
                            <template v-slot:item.type="{ item }">
                                {{ item.type == "data1" ? "기본견적" : item.type == "data2" ? "상세견적" : item.type == "file" ? "파일첨부" : "" }}
                            </template>
                            <template v-slot:item.totalAmount="{ item }">
                                {{ calculateTotalAmount(item).format() }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-icon @click="showEstimate(item)" small>mdi-pencil</v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-row justify="end">
                            <v-col cols="auto" class="px-4">
                                <v-btn @click="resetDataAndShow" color="primary" :disabled="!estimatable">작성하기</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card light v-if="showAdd" class="mt-4">
                    <v-card-title class="subtitle-2 font-weight-bold">
                        <v-row align="baseline">
                            <v-col cols="auto"> 견적서 {{ estimate._id ? "수정 " : "작성" }} </v-col>
                            <v-col cols="auto">
                                <v-select v-model="estimate.type" :items="estimateTypes" hide-details dense />
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text v-if="estimate.type == 'data1'">
                        <v-btn v-if="estimate.type == 'data1'" @click="$refs['popup-estimate1'].open()" color="secondary" class="pl-3">
                            <v-icon class="mr-2">{{ mdiFileDocumentEditOutline }}</v-icon>
                            기본 견적서 {{ estimate._id ? "수정 " : "작성" }}
                        </v-btn>
                    </v-card-text>
                    <v-card-text v-else-if="estimate.type == 'data2'">
                        <v-btn v-if="estimate.type == 'data2'" @click="$refs['popup-estimate2'].open()" color="secondary" class="pl-3">
                            <v-icon class="mr-2">{{ mdiFileDocumentEditOutline }}</v-icon>
                            상세 견적서 {{ estimate._id ? "수정 " : "작성" }}
                        </v-btn>
                    </v-card-text>
                    <v-card-text v-else-if="estimate.type == 'file'">
                        <v-row align="end">
                            <v-col>
                                <v-text-field v-model="estimate.totalAmount" label="최종금액" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="pl-0">
                                <v-file-input v-model="estimate.file" label="파일첨부" placeholder=" " hide-details how-size accept="image/*"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn @click="showAdd = false">취소</v-btn>
                            </v-col>
                            <v-col cols="auto" class="pr-4">
                                <v-btn color="primary" @click="save">{{ estimate._id ? "수정" : "저장" }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <popup-estimate-1 ref="popup-estimate1" v-model="estimate" @input="save"></popup-estimate-1>
        <popup-estimate-2 ref="popup-estimate2" v-model="estimate" @input="save"></popup-estimate-2>
    </div>
</template>
<script>
import { mdiFileDocumentEditOutline } from "@mdi/js";
import ViewCard from "../dumb/view-card.vue";
import PopupEstimate1 from "../portfolio/popup-estimate1.vue";
import PopupEstimate2 from "../portfolio/popup-estimate2.vue";
import api from "@/api";

import { calculateTotalAmount } from "@/plugins/calculateEstimateTotalAmount";

const initialEstimate = {
    _id: undefined,
    _user: undefined,
    type: null,
    vatEnable: true,
    discountType: "none",
    discountRate: 0,
    consultingRate: null,
    totalAmount: null,
    data1: [],
    data2: {
        material: { spaces: [] },
        laborCosts: { artificers: [] },
    },
    file: null,
};

export default {
    components: { ViewCard, PopupEstimate1, PopupEstimate2 },
    props: {
        inquiry: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            showAdd: false,
            estimatesHeaders: [
                {
                    text: "유형",
                    value: "type",
                },
                {
                    text: "견적금액",
                    value: "totalAmount",
                },
                {
                    text: "Actions",
                    value: "actions",
                },
            ],
            estimate: { ...initialEstimate },
            estimateTypes: [
                { text: "기본견적", value: "data1" },
                { text: "상세견적", value: "data2" },
                { text: "파일첨부", value: "file" },
            ],
            mdiFileDocumentEditOutline,
        };
    },
    mounted() {
        this.estimate._user = this._user;
    },
    methods: {
        async showEstimate(estimate) {
            this.showAdd = false;
            this.estimate = estimate;

            try {
                if (this.estimate.type == "file") this.estimate.file = await api.getResource(this.estimate.file);
            } catch (error) {
                handleError(error);
            }

            this.$nextTick(() => {
                switch (estimate.type) {
                    case "data1":
                        this.$refs["popup-estimate1"].open();
                        break;
                    case "data2":
                        this.$refs["popup-estimate2"].open();
                        break;
                    case "file":
                        this.showAdd = true;
                        break;
                }
            });
        },
        resetDataAndShow() {
            this.estimate = { ...initialEstimate, _user: this._user };

            this.showAdd = true;
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
        calculateTotalAmount,
        save() {
            this.$emit("input", this.estimate);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        _user() {
            return this.payload._user;
        },

        estimatable() {
            switch (this.inquiry?.status) {
                case "계약진행중":
                case "계약완료":
                case "취소":
                    return false;
                default:
                    return true;
            }
        },

        estimates() {
            return this.inquiry?.estimates?.filter(({ _user }) => _user == this._user) || [];
        },
    },
};
</script>
